import { http, HttpResponse } from 'msw'

import { VendorPaymentMethodApiModelStub } from '../api-models/stubs/VendorPaymentMethodApiModel.stub'
import { type VendorPaymentMethodApiModel } from '../api-models/VendorPaymentMethodApiModel'

export const mockCreateVendorPaymentMethodSuccess = (
  paymentMethod: VendorPaymentMethodApiModel = VendorPaymentMethodApiModelStub.build()
) => {
  return http.post(
    `/api/v2/ap/vendor-payment-methods/`,
    () => {
      return HttpResponse.json({ data: paymentMethod }, { status: 201 })
    },
    { once: true }
  )
}
